import styled from 'styled-components';
import { Z_INDEX } from '../../../config/ui/zIndex';
export const S = {
    Wrapper: styled.div `
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${Z_INDEX.CONFIG_HEADER};
    width: 100%;
    height: 30px;
  `,
};
